const PERSONALIZATION_SESSION_STARTED_AT_KEY = 'personalization-session-started-at';

/**
 * Returns a timestamp that survives refreshes in the current browser tab.
 * A new tab/session gets a new timestamp, allowing views learned during the
 * previous visit to affect the next personalized feed.
 */
export function getPersonalizationSessionStartedAt(): string | undefined {
  if (typeof window === 'undefined') return undefined;

  try {
    const existingValue = window.sessionStorage.getItem(PERSONALIZATION_SESSION_STARTED_AT_KEY);
    const existingTimestamp = existingValue ? Date.parse(existingValue) : Number.NaN;

    if (
      existingValue &&
      Number.isFinite(existingTimestamp) &&
      existingTimestamp <= Date.now() + 60 * 1000
    ) {
      return existingValue;
    }

    const sessionStartedAt = new Date().toISOString();
    window.sessionStorage.setItem(PERSONALIZATION_SESSION_STARTED_AT_KEY, sessionStartedAt);
    return sessionStartedAt;
  } catch {
    // Personalization should still work when browser storage is unavailable.
    return new Date().toISOString();
  }
}
